<!--
 * @Descripttion: 个人中心-个人信息
 * @Author: liaoyijun
 * @Date: 2021-09-22 11:13:10
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-11-11 17:50:24
-->
<template>
    <div>
        <div class="infobox">
            <div class="infobox-first">
                <div class="infobox-first-img">
                    <img
                        v-if="personInfo && personInfo.employeephotos"
                        :src="personInfo.employeephotos"
                        alt=""
                        class="employeephotos"
                    />
                    <img v-else src="@/assets/pics/head.png" alt="" class="default-img" />
                </div>
                <div class="infobox-first-text">
                    <div class="infobox-first-text-item first-level-box">
                        <span>
                            <span class="infobox-first-text-name">{{ localUserData.name }}</span>
                            <span>{{ localUserData.positionName }}</span>
                        </span>
                        <!-- <el-button size="mini"><i class="el-icon-user"></i> <span>经理门户</span></el-button> -->
                    </div>
                    <div class="infobox-first-text-item1">
                        <span class="infobox-first-text-item-table">工号:</span>
                        <span>{{ localUserData.sourceCode }}</span>
                    </div>
                    <div class="infobox-first-text-item1">
                        <span class="infobox-first-text-item-table">司龄:</span>
                        <span v-show="entryInfo.entryCount">{{ entryInfo.entryCount }}天</span>
                    </div>
                    <div class="infobox-first-text-item2">
                        <span class="infobox-first-text-item-table">部门:</span>
                        <div class="infobox-first-text-item-text">
                            {{ formatDep(localUserData.departmentPathName) }}
                        </div>
                    </div>
                    <div class="infobox-first-text-item1">
                        <span class="infobox-first-text-item-table">邮箱:</span>
                        <span>{{ localUserData.email }}</span>
                    </div>
                </div>
            </div>
            <div class="infobox-second">
                <div class="infobox-second-right">
                    <span>我的考勤</span>
                    <div class="infobox-second-right-icon">
                        <el-tooltip
                            class="item"
                            effect="light"
                            content="该数字为当月考勤数据，可点击考勤统计查看详情"
                            placement="right"
                        >
                            <i class="el-icon-question"></i>
                        </el-tooltip>
                    </div>
                </div>
                <div class="infobox-second-left" @click="showDialog">
                    <i class="el-icon-s-claim"></i>
                    <span>考勤统计</span>
                </div>
            </div>
            <div v-loading="loading" class="infobox-third">
                <div v-for="(item, index) in holidayDate" :key="index" class="infobox-third-item">
                    <div class="box">
                        <div class="infobox-third-item-top">
                            {{ item.num }}
                        </div>
                        <div class="infobox-third-item-bottom">
                            {{ item.title }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="infobox-fourth" @click="openHrPortal">
                <div v-for="(item, index) in appDate" :key="index" class="infobox-third-item">
                    <div class="infobox-fourth-img">
                        <img :src="item.url" alt="" />
                    </div>
                    <div>
                        <span>
                            {{ item.title }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <!-- 日历弹出框 -->
        <attendance-dialog ref="dateDialog"></attendance-dialog>
    </div>
</template>

<script>
import AttendanceDialog from "./AttendanceDialog.vue";
import { getCheckData, getPsVacation, getPersonInfo, getUserExpandInfo } from "@/api";
import { getLocalStorage, tabDate } from "@/libs/mUtils";

export default {
    name: "UserCenterInfo",
    components: {
        AttendanceDialog,
    },
    data() {
        return {
            loading: false,
            year: "", // 年
            month: "", // 月
            checkinDate: [],
            holidayDate: [],
            appDate: [
                { icon: " ", title: "补卡申请", url: require("@/assets/pics/user-center/bksq (2).png") },
                { icon: " ", title: "请假申请", url: require("@/assets/pics/user-center/bksq.png") },
                { icon: "  ", title: "销假申请", url: require("@/assets/pics/user-center/xjsq.png") },
                { icon: "", title: "加班申请", url: require("@/assets/pics/user-center/jbsq.png") },
            ],
            entryInfo: {},
            personInfo: {},
            localUserData: getLocalStorage("user").userData || {},
        };
    },
    mounted() {
        this.getPersonInfo();
        this.getUserExpandInfo();
        this.getCheckin();
    },
    methods: {
        showDialog() {
            this.$refs.dateDialog.show();
        },
        // 获取个人信息
        async getPersonInfo() {
            const auth_user = getLocalStorage("user");
            const username = auth_user.userData.username;
            try {
                const { code, body, message } = await getPersonInfo({ oaAccount: username });
                if (code === "0000") {
                    this.personInfo = body;
                } else {
                    this.$message.error(message);
                }
            } catch (err) {
                this.$message.error(err.data.message || "系统错误");
            }
        },
        // 获取假期信息
        async getPsVacation() {
            const auth_user = getLocalStorage("user");
            const username = auth_user.userData.username;

            try {
                const { code, body, message } = await getPsVacation({ userCodes: username });
                if (code === "0000") {
                    let holidayDate = [];
                    this.clipFormatDate(body).forEach((item) => {
                        this.setHolidayDate(item, holidayDate, "年假");
                        this.setHolidayDate(item, holidayDate, "调休假");
                        if (this.formatReim()) {
                            // 新服
                            this.setHolidayDate(item, holidayDate, "福利假");
                        }
                    });
                    holidayDate = holidayDate.map((item) => {
                        if (item.leaveName === "调休假") {
                            return {
                                num: item.durationOfTotal + "天",
                                title: item.leaveName,
                            };
                        } else {
                            return {
                                // num: parseFloat(item.durationOfTotal) + "/" + parseInt(item.durationOfInit),
                                num: parseFloat(item.durationOfTotal) + "天",
                                title: item.leaveName,
                            };
                        }
                    });
                    this.holidayDate = [...holidayDate, ...this.checkinDate];
                } else {
                    this.$message.error(message);
                }
            } catch (err) {
                this.$message.error(err || "系统错误");
            }
            this.loading = false;
        },
        clipFormatDate(data = []) {
            const yearDate = data
                .map((item) => {
                    if (item.leaveName === "年假" && tabDate(item.exprieDateTime, this.$dayjs().format("YYYY-MM-DD"))) {
                        return item;
                    }
                })
                .filter(Boolean);

            if (yearDate.length > 1) {
                const newYear = {
                    durationOfInit: parseFloat(yearDate[0].durationOfInit) + parseFloat(yearDate[1].durationOfInit),
                    durationOfLocked:
                        parseFloat(yearDate[0].durationOfLocked) + parseFloat(yearDate[1].durationOfLocked),
                    durationOfTotal: parseFloat(yearDate[0].durationOfTotal) + parseFloat(yearDate[1].durationOfTotal),
                    durationOfUsed: parseFloat(yearDate[0].durationOfUsed) + parseFloat(yearDate[1].durationOfUsed),
                    leaveId: yearDate[0].leaveId,
                    leaveName: yearDate[0].leaveName,
                    unit: yearDate[0].unit,
                };
                return [newYear].concat(data.filter((item) => item.leaveName !== "年假"));
            }

            return [...yearDate, ...data.filter((item) => item.leaveName !== "年假")];
        },
        setHolidayDate(source, holidayDate, desc) {
            if (source.leaveName === desc) {
                const list = holidayDate.map((item) => item.leaveName);
                if (!list.includes(source.leaveName)) {
                    holidayDate.push(source);
                }
            }
        },
        // 通过账户名称获取考勤异常统计信息
        async getCheckin() {
            this.loading = true;
            try {
                const auth_user = getLocalStorage("user");
                const username = auth_user.userData.username;
                const { code, body, message } = await getCheckData({
                    oaAccount: username,
                    checkDate: this.dateFormat(),
                });
                if (code === "0000") {
                    const { late = [], early = [], absent = [] } = body;
                    const lateCount = late.length + early.length;
                    const checkCount = absent.length;
                    this.checkinDate = [
                        { num: checkCount + "次", title: "未打卡" },
                        { num: lateCount + "次", title: "迟到早退" },
                    ];
                    this.getPsVacation();
                } else {
                    this.$message.error(message);
                }
            } catch (err) {
                this.$message.error(err.data.message || "系统错误");
            }
        },
        // 通过账户名称获取考勤异常统计信息
        async getUserExpandInfo() {
            this.loading = true;
            try {
                const auth_user = getLocalStorage("user");
                const userId = auth_user.userData.userId;
                const source = auth_user.userData.source;
                const { code, body, message } = await getUserExpandInfo({
                    userId,
                    source,
                });
                if (code === "0000") {
                    this.entryInfo = body;
                } else {
                    this.$message.error(message);
                }
            } catch (err) {
                this.$message.error(err.data.message || "系统错误");
            }
        },
        // 新服判断
        formatReim() {
            // 1263443593787666433 新希望服务
            const reim_white_list = ["1263443593787666433"];
            let orgId = "";
            const auth_user = getLocalStorage("user");
            const orgList = auth_user.userData.departmentPath.split(",");
            for (let i = 0; i < reim_white_list.length; i++) {
                const pId = reim_white_list[i];
                if (orgList.includes(pId)) {
                    orgId = pId;
                    break;
                }
            }
            if (!orgId) {
                // 新希望地产
                return false;
            }
            // 新希望服务
            return true;
        },
        dateFormat() {
            let date = new Date();
            const year = date.getFullYear();
            const month = date.getMonth() + 1;
            return year + "-" + this.monthFormat(month);
        },
        // 月
        monthFormat(month) {
            return month > 9 ? month : "0" + month;
        },
        formatDep(org) {
            return org ? org.replaceAll(">", "_") : "";
        },
        openHrPortal() {
            window.open(this.$config.hrUrl);
        },
    },
};
</script>

<style lang="scss" scoped>
.infobox {
    margin: 20px;

    .infobox-first {
        display: flex;
        margin-bottom: 40px;
        .infobox-first-img {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 141px;
            height: 200px;
            background: #f0f0f0;
            margin-right: 20px;
            .employeephotos {
                width: 100%;
                height: 100%;
            }
            .default-img {
                position: relative;
                top: -15px;
            }
        }
        .first-level-box {
            display: flex;
            justify-content: space-between;
            .el-button--mini {
                position: relative;
                top: -15px;
                right: -8px;
                color: #54a183;
                padding: 4px 6px;
                .el-icon-user {
                    font-size: 13px;
                }
            }
        }
        .infobox-first-text {
            position: relative;
            top: 18px;
            width: 207px;
            .infobox-first-text-icon {
                display: flex;
                justify-content: flex-end;
            }
            .infobox-first-text-item {
                margin-bottom: 24px;
                .infobox-first-text-name {
                    font-size: 20px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    margin-right: 8px;
                }
            }
            .infobox-first-text-item1 {
                margin-bottom: 12px;
                .infobox-first-text-item1-top {
                    width: 101px;
                    height: 20px;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #3a9d80;
                    line-height: 20px;
                    background: #eef7f7;
                    border-radius: 2px;
                    margin-left: 5px;
                }
                .infobox-first-text-item-table {
                    width: 42px;
                    height: 20px;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #999999;
                    line-height: 20px;
                    margin-right: 4px;
                    white-space: nowrap;
                }
                .infobox-first-text-item-text {
                    width: 167px;
                    font-size: 14px;
                    background: pink;
                }
            }
            .infobox-first-text-item2 {
                margin-bottom: 12px;
                display: flex;
                .infobox-first-text-item-table {
                    width: 42px;
                    height: 20px;
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #999999;
                    line-height: 20px;
                    margin-right: 4px;
                    white-space: nowrap;
                }
                .infobox-first-text-item-text {
                    width: 167px;
                    font-size: 14px;
                }
            }
        }
    }
    .infobox-second {
        display: flex;
        border-bottom: 1px solid #d9d9d9;
        padding-bottom: 11px;
        margin-bottom: 17px;
        justify-content: space-between;
        .infobox-second-right {
            // float: left;
            display: flex;
            span {
                width: 64px;
                height: 22px;
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #666666;
                line-height: 22px;
                margin-right: 12px;
            }
            .infobox-second-right-icon {
                width: 20px;
                // height: 16px;
                color: #3a9d80;
                padding-top: 5px;
                .el-icon-question {
                    font-size: 18px;
                }
            }
        }
        .infobox-second-left {
            cursor: pointer;
            .el-icon-s-claim {
                font-size: 18px;
            }
            span {
                width: 408px;
                height: 508px;
                background: #ffffff;
                border-radius: 8px;
                padding-left: 2px;
            }
        }
    }
    .infobox-third {
        width: 368px;
        height: 92px;
        background: #ffffff;
        border-radius: 4px;
        border: 1px solid #f2f2f2;
        display: flex;
        padding-top: 23px;
        padding-bottom: 23px;
        justify-content: center;
        margin-bottom: 27px;
        .infobox-third-item {
            flex-wrap: wrap;
            display: flex;
            align-items: center;
            justify-content: center;
            height: 37px;
            flex: 1;
            // width: 73px;
            border-right: 1px solid #f2f2f2;
            padding-bottom: 24px;

            .infobox-third-item-top {
                text-align: center;
                padding-bottom: 7px;
            }
            .infobox-third-item-bottom {
                text-align: center;
            }
        }
    }
    .infobox-fourth {
        height: 50px;
        display: flex;
        justify-content: space-between;
        .infobox-third-item {
            height: 56px;
            width: 58px;
            font-size: 14px;
            font-weight: 400;
            color: #666666;
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            cursor: pointer;
            .infobox-fourth-img {
                width: 22px;
                height: 22px;
                img {
                    width: 100%;
                    height: 100%;
                }
            }
        }
    }

    .infobox-third :last-child {
        border-right: 1px solid white;
    }
}
</style>
